var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"col-lg-2-4 col-md-3 col-sm-4 col-xs-12  no-padding"},[_c('cart-item',{attrs:{"item":item}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }